var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMixte(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 35,
    height: 35,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.10821 16.375L3.22488 16.8416V9.31663L1.19988 14.2C0.858213 15.05 1.26655 16.025 2.10821 16.375ZM18.3582 13.2916L14.2249 3.31663C13.9665 2.69163 13.3582 2.30829 12.7165 2.29163C12.4999 2.29163 12.2749 2.32496 12.0582 2.41663L5.91655 4.95829C5.29155 5.21663 4.90821 5.81663 4.89155 6.45829C4.88321 6.68329 4.92488 6.90829 5.01655 7.12496L9.14988 17.1C9.40821 17.7333 10.0249 18.1166 10.6749 18.125C10.8915 18.125 11.1082 18.0833 11.3165 18L17.4499 15.4583C18.2999 15.1083 18.7082 14.1333 18.3582 13.2916ZM6.56655 7.29163C6.10821 7.29163 5.73321 6.91663 5.73321 6.45829C5.73321 5.99996 6.10821 5.62496 6.56655 5.62496C7.02488 5.62496 7.39988 5.99996 7.39988 6.45829C7.39988 6.91663 7.02488 7.29163 6.56655 7.29163ZM4.89988 16.4583C4.89988 17.375 5.64988 18.125 6.56655 18.125H7.77488L4.89988 11.175V16.4583Z",
    fill: "#3367CD"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMixte);
export default __webpack_public_path__ + "static/media/mixte.5efb55bf.svg";
export { ForwardRef as ReactComponent };